/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
import NavbarNotAuth from '../../../userNotAuth/components/navbarNotAuth'
import { useNavigate } from 'react-router-dom'
import NavbarTopAdmin from '../../../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../../../admin/components/navbarBottomAdmin'
import axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import DivBottom from '../../../userNotAuth/components/divBottom'

function ProfiloRistorante() {
    const navigate = useNavigate()
    const userId = localStorage.getItem('id')
    const [ristoranti, setRistoranti] = useState([])
    const [dati, setDati] = useState({})
    const [msg, setMsg] = useState({ noProfilo: null })
    const confirmElimina = useRef()
    const corpo = useRef()//per opacity diminuita quando clicco elimina artista

    async function getRistorante() {
        try {
            const res = await axios.post(`/getArtista/${userId}`)
            setRistoranti(res.data.filter(item => item.sezione === "risto"))
            if (res.data.length === 0) setMsg({
                noProfilo: 'Non hai ancora nessun profilo ristorante da mostrare'
            })
        } catch (err) { console.log(err) }
    }
    function modifica(risto) {
        setTimeout(() => {
            navigate('/editRistorante', {
                replace: true,
                state: { risto }
            })
        }, 300)
    }
    useEffect(() => { getRistorante() }, [userId])

    const approva = (stato) => {
        try {
            axios.post(`/approvaArtista/${dati.id}/${dati.emailUser}/${stato}/${dati.idUser}`).then(res => {
                confirmElimina.current.style.top = '-50%'
                corpo.current.style.opacity = "1"
                document.body.style.overflow = "scroll"
                if (stato === 'delete') {
                    if (dati.img) { axios.delete(`/delete-img/${dati.img}`) }
                    if (dati.video) { axios.delete(`/delete-video/${dati.video}`) }
                }
                setTimeout(() => { window.location.reload() }, 300)
            })
        } catch (err) { console.log(err) }
    }
    // useEffect(() => { console.log('dati:', dati) }, [dati])
    return (<>
        {localStorage.getItem('email') ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <br />
        <div ref={confirmElimina}
            style={{
                position: 'fixed',
                backgroundColor: 'snow',
                top: '-50%',
                left: '0',
                right: '0',
                margin: 'auto',
                width: '70%',
                height: '40%',
                padding: '2rem',
                zIndex: '1',
                borderRadius: '10px',
                border: '1px solid black',
                textAlign: 'center',
                transition: '.2s'
            }}>
            Eliminare definitivamente <i>{dati.nome}</i> ?
            <div className='mt-5'>
                <button className='float-start btn btn-danger'
                    onClick={() => { approva('delete') }}>Procedi</button>
                <button className='float-end btn btn-success'
                    onClick={() => {
                        confirmElimina.current.style.top = '-50%'
                        corpo.current.style.opacity = "1"
                        document.body.style.overflow = "scroll"
                    }}>Annulla</button>
            </div>
        </div>
        <h1 style={{ cursor: 'pointer', margin: '2em 0 0 .5em' }} onClick={() => { navigate('/', { replace: true }) }}>◁</h1>
        <div className='container' ref={corpo}>
            <h3 style={{ marginTop: '1rem', textAlign: 'center' }}>PROFILO RISTORANTE</h3>
            {msg.noProfilo && <h5 style={{ margin: '3em 0 14rem 0' }}>{msg.noProfilo}</h5>}
            {ristoranti &&
                ristoranti.map((risto) => {
                    return (
                        <div key={risto.id} style={{ marginTop: '3rem' }} className='bodyPadding'>
                            <hr />
                            <div style={{
                                margin: '0 3px', overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden', height: '100%'
                            }}>
                                {risto.img &&
                                    risto.img.split(',').map((photo, index) => (
                                        // eslint-disable-next-line jsx-a11y/alt-text
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${photo}`} key={index + 'awe'}
                                            style={{ width: '250px', height: '180px', margin: '3px', objectFit: 'cover' }} />
                                    ))
                                }
                            </div>

                            <div className='mt-2 fs-2'><b> {risto.nome}</b>
                                <p className='fs-5'>Genere: <i>{risto.genere}</i></p>
                            </div>

                            <div><i>{risto.soggetto}</i> - {risto.regione} <br />{risto.città}</div>

                            <p className='mt-5 text-center'>DESCRIZIONE</p>
                            <p style={{ fontStyle: 'italic', fontSize: 'medium' }} className='form-control'>{risto.descrizione}</p>
                            <div className='mt-3'>
                                {risto.telefono &&
                                    // eslint-disable-next-line jsx-a11y/alt-text
                                    <div className='mt-5'>
                                        <img src={require('../../../userNotAuth/image/icons8-telefono-cellulare-48.png')} width='25rem' style={{ marginRight: '1rem' }} />
                                        {risto.telefono}
                                    </div>
                                }
                                {risto.email &&
                                    <div className='mt-1'><img src={require('../../../userNotAuth/image/icons8-nuovo-messaggio-48.png')} width="25rem" style={{ marginRight: '1rem' }} />
                                        {risto.emailUser}
                                    </div>
                                }
                                {/* ------------------------- VIDEO ----------------------- */}
                                {risto.video &&
                                    <div className='mt-5' style={{ border: '1px solid lightgrey', borderRadius: '5px', padding: ' 15px' }}>
                                        <div className='text-center mt-3'>
                                            <video src={`https://leuro-bucket.s3.amazonaws.com/video/${risto.video}`} id={'videoPreview'}
                                                style={{ width: '100%', borderRadius: '5px' }} controls />
                                        </div>
                                    </div>
                                }

                            </div>

                            {risto.url &&
                                <div className='mt-5'>Sito web: <i style={{ fontWeight: '600' }}>
                                    <a href={risto.url} target='_blank'>{risto.url.substring(0, 28)}...</a>
                                </i>
                                </div>
                            }
                            {risto.fb &&
                                <div className='mt-2'>F Book: <i style={{ fontWeight: '600' }}>
                                    <a href={risto.fb} target='_blank'>{risto.fb.substring(0, 28)}...</a>
                                </i>
                                </div>
                            }
                            {risto.youtube &&
                                <div className='mt-2'>Y Tube: <i style={{ fontWeight: '600' }}>
                                    <a href={risto.youtube} target='_blank'>{risto.youtube.substring(0, 28)}...</a>
                                </i>
                                </div>
                            }
                            <div className='mt-5'>Creato il {risto.created_at}</div>
                            <div className='mt-5' style={{ marginBottom: '6rem' }}>
                                <button className='btn btn-primary float-start' onClick={() => { modifica(risto) }}
                                    style={{ fontSize: 'medium' }}>
                                    Modifica
                                </button>
                                <button className='btn btn-danger float-end' style={{ fontSize: 'medium' }}
                                    onClick={() => {
                                        setDati(risto)
                                        document.body.style.overflow = "hidden"
                                        corpo.current.style.opacity = ".4"
                                        confirmElimina.current.style.top = '30%'
                                    }}>
                                    Elimina
                                </button>
                            </div><br />
                        </div>

                    )
                })}
            <button style={{ cursor: 'pointer', margin: '2em 0 0 .5em' }} onClick={() => { navigate('/', { replace: true }) }}>◁<i> indietro</i></button>
            {ristoranti.length === 0 && <h4 className='text-center mt-5'>Non hai nessun profilo ristorante</h4>}
        </div>
        <DivBottom />
    </>)
}
export default ProfiloRistorante